import { observable, action, runInAction } from "mobx";
import service from "../services";

export default class CompaniesStore {
    rootStore;

    constructor(rootStore) {
        this.rootStore = rootStore;
    }

    @observable companiesList = [];
    @observable loadingList = false;

    @action loadCompanies = async () => {
        this.loadingList = true;

        try {
            const companies = await service.Company.getAll();
            runInAction("loading companies", () => {
                this.companiesList = companies;
                // users.forEach((user) => {
                //   this.userRegistry.set(user.id, user);
                // });
                this.loadingList = false;
            });
        } catch (error) {
            runInAction("loading companies error", () => {
                this.loadingList = false;
            });
        }
    };

    @action loadCompany = async (companyId) => {
        try {
            let user = await service.Company.get(companyId);
            return runInAction("get company", async () => {
                return user;
            });
        } catch (error) {
            return runInAction("get company error", () => {
                return null;
            });
        }
    };

    @action save = async (company) => {
        try {
            await service.Company.save(company);
            return runInAction("save company", async () => {
                return { success: true };
            });
        } catch (error) {
            return runInAction("save company error", () => {
                return { success: false };
            });
        }
    };

    @action edit = async (companyId, company) => {
        try {
            await service.Company.edit(companyId, company);
            return runInAction("edit save company", async () => {
                return { success: true };
            });
        } catch (error) {
            return runInAction("edit save company error", () => {
                return { success: false };
            });
        }
    };

    @action newCompany = () => {
        return {
            id: null,
            name: "",
            email: "",
            adminUserName: "",
            adminPassword: ""
        }
    }
}